import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-delete-account-unable',
  templateUrl: './delete-account-unable.component.html',
  styleUrls: ['./delete-account-unable.component.scss'],
})
export class DeleteAccountUnableComponent {
  @Input() dialogRef?: any;
  @Input() stepper!: number;
  @Input() siteList: string[] = [];
  @Output() stepperChange = new EventEmitter<number>();

  constructor(private localizationService: LocalizationService) {
    this.localizationService.setupLocalization();
  }

  closeDialog(): void {
    this.dialogRef?.close();
  }
}
